"use client";
import React, { createContext, useContext, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../config/apiconfig";

const PromoCodeContext = createContext();

export const PromoCodeProvider = ({ children }) => {
  const [promoCodes, setPromoCodes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPromoCodes = async (productId) => {
    setLoading(true);
    setError(null);

    try {
      const res = await axios.get(
        `${BASE_URL}/promo-codes/${productId}`
      );

      setPromoCodes(res.data.data);
    } catch (err) {
      if (err.response?.status === 404) {
        setPromoCodes([]);
        setError(err.response.data.message);
      } else {
        setError("Failed to fetch promo codes");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <PromoCodeContext.Provider
      value={{ promoCodes, loading, error, fetchPromoCodes }}
    >
      {children}
    </PromoCodeContext.Provider>
  );
};

export const usePromoCodes = () => useContext(PromoCodeContext);
